export function booleanFormatter(value: boolean): string {
  return value === true ? 'Yes' : 'No';
}
